<template>
  <div id="home">
    <my-header></my-header>

    <div class="pd20">
      <h3>Đăng ký khuyến nông viên</h3>
      <form v-on:submit.prevent="submitForm" v-if="ready">
        <div class="row">
          <div class="col-md-8 mb20">

            <div class="mt20">
              <selectlocation
                :province="item.province_id"
                :district="item.district_id"
                :commune="item.commune_id"
                :is_get_location="false"
                :is_required="true"
                :p_location="item.location_coord"
                @updateLocation="updateLocation"
              ></selectlocation>
            </div>

            <label  class="mt20">{{ "Các cây trồng trong khu vực " | translate }}:</label>
            <input name="tags" placeholder="nhập tên sản phẩm" value autofocus />

          </div>

        </div>

        <button class="btn btn-info mt20" type="submit" :disabled="working">
          <i v-if="working" class="fas fa-spinner fa-spin"></i>
          Đăng ký
        </button>
      </form>
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import Tagify from '@yaireo/tagify'
export default {
  name: 'FurtherInfo',
  components: {
    MyHeader,
    Loading,
    selectlocation
  },
  data () {
    return {
      user: null,
      type: '',
      tagify: null,
      working: false,
      item: null,
      ready: false
    }
  },

  methods: {
    defaultValue () {
      return {
        province_id: '',
        district_id: '',
        commune_id: ''
      }
    },
    updateLocation (data) {
      for (let key in data) {
        this.item[key] = data[key]
      }
      console.log('this.item', this.item)
    },
    getPlants () {
      Utils.getAllPlants(this, {}).then((plants) => {
        this.plants = plants

        setTimeout(() => {
          let input = document.querySelector('input[name=tags]')
          // init Tagify script on the above inputs
          let whiteList = []
          if (this.plants.length > 0) {
            whiteList = this.plants.map(function (item) {
              return { value: item.name, id: item.id, searchBy: item.unaccent_name }
            })
          }
          // console.log('whiteList', whiteList)
          this.tagify = new Tagify(input, {
            whitelist: whiteList,
            enforceWhitelist: true
          })
          if (this.item && this.item.plants) {
            let insert = this.item.plants.map(plant => {
              return {value: plant.name, id: plant.id}
            })
            this.tagify.addTags(insert)
          }
        }, 100)
      })
    },

    submitForm () {
      let data = JSON.parse(JSON.stringify(this.item))

      data.plant_ids = this.tagify.value.map(item => {
        return item.id
      })

      // console.log('plant_ids', plant_ids)

      let request = Utils.requestV2(this, true).post(`/encourage-agricultures/`, data)

      this.working = true
      request
        .then((response) => {
          let data = response.data
          console.log('data', data)

          this.logicFinish()
          this.working = false
        })
        .catch((error) => {
          // this.working = false;
          Utils.showErrorMessage(this, error.response)
          this.working = false
        })
        .finally(() => {})
    },
    logicFinish () {
      this.$alertify.success('Thông tin của bạn đã được gửi')
      this.$router.push({ name: 'DownloadApps' })
    }

  },

  mounted () {
    this.type = this.$route.params.type
    this.user = Utils.getUser(this)
    if (!this.user) {
      this.$router.push({ name: 'Home' })
    }
    this.getPlants()
    this.item = this.defaultValue()
    this.ready = true
  },
  beforeDestroy () {}
}
</script>



// WEBPACK FOOTER //
// src/components/forms/FormRegisterEncourageAgriculture.vue